/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Banner_Remove_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "This removes the tournament banner for everyone. You can upload a new one anytime." |
*
* @param {Tournament_Banner_Remove_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_banner_remove_confirm_body = /** @type {((inputs?: Tournament_Banner_Remove_Confirm_BodyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Banner_Remove_Confirm_BodyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela supprime la bannière du tournoi pour tous les participants. Vous pouvez en téléverser une nouvelle à tout moment.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto elimina el banner del torneo para todos. Puede subir uno nuevo en cualquier momento.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Isso remove o banner do torneio para todos. Você pode enviar um novo a qualquer momento.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il banner del torneo verrà rimosso per tutti. È possibile caricarne uno nuovo in qualsiasi momento.")
	return /** @type {LocalizedString} */ ("This removes the tournament banner for everyone. You can upload a new one anytime.")
});